module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pages"
    }
  }, [_vm._v("Pagina's")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Pagina's")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pages), function(p, id) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'PageEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1)])
  }))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-modal",
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body"
  }, [_c('form', [_c('fieldset', {
    staticClass: "uk-fieldset"
  }, [_c('div', {
    staticClass: "uk-margin"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPage.name),
      expression: "newPage.name"
    }],
    staticClass: "uk-input",
    attrs: {
      "type": "text",
      "placeholder": "Naam"
    },
    domProps: {
      "value": (_vm.newPage.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newPage, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('div', {
    staticClass: "uk-align-right"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.add($event)
      }
    }
  }, [_vm._v("Uitnodigen")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-align-right"
  }, [_c('a', {
    attrs: {
      "href": "#page-modal",
      "uk-toggle": "",
      "uk-icon": "icon: plus; ratio: 2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Laatste update")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "60"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: copy; ratio: 1.2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title"
  }, [_vm._v("Pagina maken")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eec24094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/PAGES/Pages.vue
// module id = 527
// module chunks = 1